
import { number, addMethod } from 'yup';

export const isRegularCategory = (category) => {
  const specialParams = ['max_loss', 'auto_liquidate', 'autoliq', 're_enable'];
  return !specialParams.includes(category?.name);
}

export const createFormFieldValidation = (name) => {
  addMethod(number, name, function (activeRiskSetting) {
    return this.test(`isValid${name}`, function (value) {
      const { path, createError } = this;
      if (value === activeRiskSetting.settings?.default) {
        return createError({ path, message: "New value should differ from the current value" });
      }

      if (isRegularCategory(activeRiskSetting) && value > 100000000) {
        return createError({ path, message: "Maximum allowed value: 100,000,000" });
      }

      if (!isRegularCategory(activeRiskSetting) && value > 10000000) {
        return createError({ path, message: "Maximum allowed value: 10,000,000" });
      }

      return true;
    });
  });
}